import { createTheme } from '@mui/material/styles';
import CustomIcon from '@components/shared/CustomIcon/CustomIcon';
import localFont from 'next/font/local';
import { Box } from '@mui/material';
export const fontRoboto = localFont({
  src: [
    {
      path: '../public/fonts/roboto/Roboto-Regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../public/fonts/roboto/Roboto-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../public/fonts/roboto/Roboto-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  fallback: ['Arial', 'sans-serif'], // Fuente de respaldo en caso de que Roboto no cargue
});

export const fontEncodeSans = localFont({
  src: '../public/fonts/encode-sans/EncodeSans-VariableFont_wdth,wght.ttf',
  style: 'normal',
  fallback: ['Arial', 'sans-serif'], // Fuente de respaldo en caso de que Roboto no cargue
});

const theme = createTheme({
  breakpoints: {
    values: {
      sliderHome: 1265,
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1550,
      schedulerMobile: 750,
    },
  },
  fonts: {
    roboto: `${fontRoboto.style.fontFamily}, Arial, sans-serif`,
  },
  typography: {
    fontFamily: `${fontRoboto.style.fontFamily}`,
    h2: {
      fontSize: '30px',
      fontWeight: '700',
      color: '#1976D2',
      fontFamily: `${fontEncodeSans.style.fontFamily}`,
    },
    h3: {
      fontSize: '22px',
      fontWeight: '700',
      color: '#000000',
      fontFamily: `${fontEncodeSans.style.fontFamily}`,
    },
    h4: {
      fontSize: '20px',
      fontWeight: '600',
      color: '#000000',
      fontFamily: `${fontRoboto.style.fontFamily}`,
    },
    h5: {
      fontSize: '20px',
      fontWeight: '500',
      color: '#000000',
      fontFamily: `${fontRoboto.style.fontFamily}`,
    },
    h6: {
      fontSize: '16px',
      fontWeight: '500',
      color: '#000000',
      fontFamily: `${fontRoboto.style.fontFamily}`,
    },
    body1: {
      fontFamily: `${fontRoboto.style.fontFamily}`,
    },
    body2: {
      fontFamily: `${fontEncodeSans.style.fontFamily}`,
    },
  },
  palette: {
    common: {
      black: '#000',
      white: '#fff',
      blue: '#1976D2',
      boBlue: '#ECF2F9',
      grey: '#F2F2F2',
      green: '#2E7D32',
      red: '#D32F2F',
      greyHeaderTable: '#535554',
      greyBorderCard: '#ABACAC',
      greyBackground: '#F5F5F5',
      lightBlue: '#e1eff5',
      darkBlue: '#013654',
      greyViewType: '#969898',
      greyHeaderTableGanttLicenses: '#ececec',
      yellowSearch: '#ECD59980',
      lightBlueBackground: '#E3F2FDB2',
      borderColorGrey: '#D4D5D5',
      warningText: '#5E2B00',
      lightOrange: '#FDF0E6',
      orange: '#F7941E',
    },
    primary: {
      main: '#1976D2',
      light: '#034c8c',
      dark: '#023059',
      contrastText: '#fff',
    },
    secondary: {
      main: '#262626',
    },
    error: {
      main: '#D32F2F',
    },
    warning: {
      main: '#ED6C02',
      light: '#ED6C02',
      dark: '#5F2B01',
    },
    success: {
      main: '#2E7D32',
    },
    disabled: {
      main: '#6F7271',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      disabled: '#8d8d8d',
    },
    scheduler: { myRow: 'rgba(233, 234, 234, 0.5)' },
    license_status: {
      approved: '#2E7D32',
      in_process: '#50B8B1',
      hr_pending: '#50B8B1',
      rejected: '#D32F2F',
      interrupted: '#535554',
      cancelled: '#535554',
      document_pending: '#FFEEE1',
      document_loaded: '#FFEEE1',
      expired: '#535554',
      to_be_discounted: '#D32F2F',
      not_justified: '#D32F2F',
      rrhh_approved: '#2E7D32',
      justified: '#2E7D32',
    },
    irregularities_status: {
      justified: '#D2E9D4',
      pendiente: '#FFEEE1',
      en_evaluacion_medica: '#50B8B133',
      en_evaluacion: '#50B8B133',
      aprobada: '#D2E9D4',
      rechazada: '#FFD2D2',
      a_descuento: '#FFD2D2',
      no_a_descuento: '#2E7D32',
      compensada: '#3ac7ef33',
      no_justificada: '#FFD2D2',
      en_rrhh: '#50B8B133',
      justificada_final: '#D2E9D4',
      en_proceso: '#50B8B1',
    },
    directory: { fontLetter: '#6F7271' },
    grey: {
      1: '#f1f1f1',
      3: '#f2f6f8',
      4: '#f7f7f7',
      5: '#557488',
      6: '#E9EAEA',
      7: '#3c5662',
      8: '#535554', // gris 8
      9: '#303638',
      10: '#1C1B1A', // gris 10
    },
  },
  shape: {
    classic: {
      borderRadius: '5px',
      border: '1px solid #EBEBEB',
    },
  },
  shadows: [
    'none', // 0
    '-2px 7px 10px rgba(0, 0, 0, 0.2)', // 1
    '0px 0px 10px rgba(0, 0, 0, 0.3)', // 2
    '-2px 5px 5px rgba(0, 0, 0, 0.2)', // 3
    'none', // 4
    'none', // 5
    'none', // 6
    'none', // 7
    '0px 1px 2px 0px rgba(0,0,0,0.7)', // 8
    '0px 2px 5px rgba(0, 0, 0, 0.16)', // 9
    '0px 4px 20px rgba(0, 0, 0, 0.2)', // 10
    '0px 3px 5px rgba(0, 0, 0, 0.16)', // 11
    '0px 4px 8px rgba(0, 0, 0, 0.2)', // 12
    '0px 10px 12px rgba(0, 0, 0, 0.2)', // 13
    '0px 1px 1px 1px rgba(0, 0, 0, 0.25)', // 14
    '0px 3px 10px rgba(0, 0, 0, 0.3)', // 15
    '0px 3px 7px 0px #000000BF', // 16
    'none', // 17
    'none', // 18
    'none', // 19
    'none', // 20
    '0px 1px 3px 0px #0000001F, 0px 1px 1px 0px #00000024, 0px 2px 1px -1px #00000033', // 21
    '0 2px 2px 2px lightgray', // 22
    '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.2)', // 23
    '0px 1px 10px 0px #0000001F, 0px 4px 5px 0px #00000024, 0px 2px 4px -1px #00000033', // 24
  ],
  transitions: {
    easing: {
      ease: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
    },
    duration: {
      shortest: 150,
      short: 200,
      standard: 400,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: 'primary',
        variant: 'contained',
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 50,
          fontFamily: `${fontRoboto.style.fontFamily}`,
          fontWeight: 500,
          height: 36,
          textTransform: 'none',
          letterSpacing: '0.4px',
          lineHeight: '24px',
        },
      },
    },
    MuiInput: {
      defaultProps: {
        autoComplete: 'off',
      },
      styleOverrides: {
        root: {
          border: '1px solid rgba(0, 0, 0, 0.12)',
          borderRadius: '3.5px',
          paddingLeft: '16px',
          paddingRight: '16px',
          textDecoration: 'none',
        },
      },
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
      styleOverrides: {
        root: {
          textDecoration: 'none',
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        tooltip: {
          backgroundColor: '#535554',
          padding: '8px 25px',
          borderRadius: '6px',
          fontSize: '13px',
        },
        arrow: {
          color: '#535554',
        },
      },
    },
    MuiCalendarOrClockPicker: {
      styleOverrides: {
        root: {
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CustomIcon
              name='CaretDown'
              color='#0000008a'
              size={18}
              weight='bold'
            />
          </Box>
        ),
      },
    },
  },
});

export default theme;
